import React, { useMemo } from 'react';
import { arr } from '@/features/shared/lib/utils';

export default function ExtraLinks({ record }) {
  const items = useMemo(() => {
    const list = [];
    if (!record) return list;

    // const themeUrl = (typeof rmVars !== 'undefined' && rmVars.themeUrl) ? rmVars.themeUrl : '';

    // 1) Direct IDs -> External official pages
    if (record.wos_id) {
      list.push({
        key: 'wos-id',
        label: 'JCR Journal',
        href: `https://jcr.clarivate.com/jcr-jp/journal-profile?journal=${encodeURIComponent(record.wos_id)}&year=All%20years`,
      });
    }
    if (record.scopus_id) {
      list.push({
        key: 'scopus-id',
        label: 'Scopus Journal',
        href: `https://www.scopus.com/sourceid/${encodeURIComponent(record.scopus_id)}`,
      });
    }
    if (record.kci_id) {
      list.push({
        key: 'kci-id',
        label: 'KCI Journal',
        href: `https://www.kci.go.kr/kciportal/po/search/poCitaView.kci?sereId=${encodeURIComponent(record.kci_id)}`,
      });
    }

    // 2) Proxy links by journal_category and ISSN (fallback style from legacy code)
    const issn = record?.issn || '';
    const cat = arr(record?.journal_category);
    cat.forEach((item, idx) => {
      const type = String(item?.category_type || '').toLowerCase();
      if (!issn) return; // need ISSN for proxy URLs
      if (typeof rmVars === 'undefined') return;
      const base = rmVars.proxyUrl || '';
      if (!base) return;

      if (type.includes('kci')) {
        const url = base + (rmVars.kciJournalUrl || '') + issn;
        list.push({ key: `kci-${idx}`, label: 'KCI', href: url });
      } else if (type.includes('scopus')) {
        const url = base + (rmVars.scopusJournalUrl || '') + issn;
        list.push({ key: `scopus-${idx}`, label: 'Scopus', href: url });
      } else {
        const url = base + (rmVars.jcrJournalUrl || '') + issn;
        list.push({ key: `jcr-${idx}`, label: 'JCR', href: url });
      }
    });

    // De-duplicate by href
    const seen = new Set();
    return list.filter(it => {
      if (!it.href) return false;
      const h = String(it.href);
      if (seen.has(h)) return false;
      seen.add(h);
      return true;
    });
  }, [record]);

  return (
    <div className="w-full p-8 bg-white rounded-xl">
      <h2 className="flex items-center gap-[6px] mb-5">
        <img src={`${rmVars.themeUrl}images/link-ico.png`} className="w-[22px]" alt="link icon"/>
        <span className="text-[18px] font-bold">Extra Link</span>
      </h2>

      {items.length === 0 ? (
        <div className="text-[14px] text-[#6C7687]">No extra links.</div>
      ) : (
        <div className="flex flex-col gap-1">
          {items.map(it => (
            <a key={it.key} href={it.href} target="_blank" rel="noopener noreferrer" className="flex justify-between items-center px-[14px] py-[10px] bg-[#F3F5F9] rounded-md">
              <span className="text-[#376BDB] text-[14px] font-semibold">{it.label}</span>
              <img src={`${rmVars.themeUrl}images/launch-ico-bl.png`} className="w-[18px]" alt="launch"/>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
